import { activationClasses } from '../common/consts';

export class PressCenterPage {
    private pressCenterSearchSwitchItems: HTMLElement[];
    private pressCenterSearch: HTMLElement | null;
    constructor() {
        this.pressCenterSearchSwitchItems
            = Array.prototype.slice.call(document.querySelectorAll('[data-press-center-search-switch]'));
        this.pressCenterSearch = document.querySelector('[data-press-center-search]');
    }

    handlerToggle() {
        this.pressCenterSearchSwitchItems.forEach((pressCenterSearchSwitchItem: HTMLElement) => {
            pressCenterSearchSwitchItem.addEventListener('click', () => {
                if (this.pressCenterSearch) {
                    pressCenterSearchSwitchItem.classList.toggle(activationClasses.active)
                    this.pressCenterSearch.classList.toggle(activationClasses.active);
                }
            });
        });
    }
}
